import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/layout/index'
import styled from 'styled-components'
import Container from 'components/elements/container'
import { fontWeight } from 'themes/font'
import $Question from 'components/faq/item'
import GetStarted from 'components/get-started'
import breakPoints from 'themes/breakPoints'

const Section = styled.section`
  @media (max-width: ${breakPoints.md.max}px) {
    padding: 32px 0;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    padding-top: 112px;
  }
`

const Heading = styled.h1`
  font-size: 40px;
  font-weight: ${fontWeight.medium};
  color: #000000;
  @media (max-width: ${breakPoints.md.max}px) {
    margin-bottom: 32px;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    margin-bottom: 56px;
  }
`

const Questions = styled.div`
  @media (max-width: ${breakPoints.md.max}px) {
    width: 100%;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    width: 80%;
  }
`

const Question = styled($Question)`
  @media (max-width: ${breakPoints.md.max}px) {
    margin-bottom: 32px;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    margin-bottom: 56px;
  }
`

const Background = styled.div`
  @media (max-width: ${breakPoints.md.max}px) {
    display: none;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    display: flex;
    justify-content: flex-end;
    padding-top: 120;
  }
`

export default class FAQPage extends React.PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  render () {
    const data = this.props.data.markdownRemark.frontmatter
    return (
      <Layout title={data.title}>
        <Section className='wow fadeIn'>
          <Container>
            <Heading>{data.title}</Heading>
            <Questions>
              {data.questions.map((question, index) => (
                <Question
                  key={index}
                  question={question.questionContent}
                  answer={question.answerContent}
                />
              ))}
            </Questions>
          </Container>
          <Background>
            <img src='/img/bg/bg-2.svg' alt='' />
          </Background>
        </Section>
        <GetStarted data={data.getStarted} />
      </Layout>
    )
  }
}

export const faqPageQuery = graphql`
  query FAQPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        questions {
          questionContent
          answerContent
        }
        getStarted {
          heading
          button {
            text
            link
          }
        }
      }
    }
  }
`
